<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="100%" fullscreen>
      <v-card>
        <v-card-text class="pa-0">
          <GridSyclus
            :idRecursoSistema="100012"
            title="Clientes"
            :headers="clienteHeaders"
            :customHeaders="customHeaders"
            :items="clientes"
            item-key="IdCliente"
            :loading="loading"
            :setaTag="false"
            :modal="true"
            @changeLayoutSql="changeLayoutSql"
            @aplicaFiltros="aplicaFiltros"
            @vinculaClientes="$emit('vinculaClientes', $event)"
            @fecharModal="$emit('input')"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import GridSyclus from '@/components/shared/GridSyclus';
export default {
  name: 'ModalListAtividade',
  props: ["value"],
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100012
      },
      loading: false,
      searchTerm: '',
      clienteHeaders: [
        { text: "ID", value: "IdCliente" },
        { text: "Fantasia", value: "Fantasia" },
        { text: "Nome/Razão Social", value: "RazaoSocial" },
        { text: "Tags", value: "Tags" },
        { text: "Status", value: "Status" }
      ],
      customHeaders: ["Status"],
    }
  },
  components: {
    GridSyclus,
  },
  computed: {
    ...mapGetters(["clientes", 'user',])
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue) this.aplicaFiltros();
    }
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions(['fetchLayoutsSqlUsuario', 'fetchClientesSql']),
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100012 });
      await this.fetchClientesSql(this.args);
      this.loading = false;
    },
  }
};
</script>

<style>
</style>
